import gql from 'graphql-tag'

export const ALL_CREDIT_CARDS = gql`
  query AllCreditCards($brandUuid: ID) {
    allCreditCards(brandUuid: $brandUuid) {
      id
      last4Digits
      permission
      cardBrand
      owner {
        firstName
        lastName
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/AllCreditCards.tsx